import { render } from "./SoftwareSolution.vue?vue&type=template&id=5de2ec70"
import script from "./SoftwareSolution.vue?vue&type=script&lang=js"
export * from "./SoftwareSolution.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__